import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translate } from "./dict";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("elvis_lang") || "en");
  const [dir, setDir] = useState("ltr");

  const setLang = (code, direction = "ltr") => {
    setLangState(code);
    setDir(direction);
    localStorage.setItem("elvis_lang", code);
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", code);
  };

  useEffect(() => {
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang, dir]);

  const t = (key) => translate(lang, key);

  return (
    <I18nContext.Provider value={{ lang, dir, setLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}

export function labelOf(labelsMap, lang, fallback = "") {
  if (!labelsMap) return fallback;
  return labelsMap[lang] || labelsMap.en || Object.values(labelsMap)[0] || fallback;
}
